module.exports = __webpack_public_path__ + "static/img/idtype_evse.81c04114.png";